import { FieldTypeEnum } from 'packages/sdks-next/growp'
import { ReqWithMetaData } from '../types'
import { isEmpty } from '@seiue/util'
import { AnyType, AnyValueObj } from 'packages/types'
import { UploadFile } from 'antd/lib/upload'

/**
 * 问卷数据分页
 * @param originQuestionnaires - 原始问卷数据
 * @returns 分页处理后的问卷数据
 */
export const QuestionnairePagination = (
  originQuestionnaires: ReqWithMetaData[]
) => {
  const finalData: { [key: number]: ReqWithMetaData[] } = {}
  let page = 1
  let list: ReqWithMetaData[] = []
  const lastIndex = originQuestionnaires.length - 1
  let num = 0
  originQuestionnaires.map((question, index) => {
    if (question.type === FieldTypeEnum.PageBreak) {
      finalData[page] = [...list]
      list = []
      if (index !== lastIndex) {
        page = page + 1
      }
    } else {
      if (question.type !== FieldTypeEnum.Describe) {
        num++
      }
      list.push({ ...question, index: num })
      if (index === lastIndex) {
        finalData[page] = [...list]
      }
    }
  })
  const data = isEmpty(finalData) ? { 1: list } : finalData
  return {
    data,
    total: page,
  }
}

/**
 * antd Form Uplaod 上传时 Form.Item的getValueFromEvent属性值
 *
 * @param info - 文件信息
 * @returns
 */
export const normFile = (info: AnyType) => {
  const list = info.fileList || []
  const pattern = /\?t=[0-9]*$/
  return list
    .filter((file: UploadFile) => file.url)
    .map((file: UploadFile) => {
      let fileUrl = file.url
      if (fileUrl) {
        fileUrl = pattern.test(fileUrl)
          ? fileUrl.replace(pattern, `?t=${+new Date()}`)
          : `${fileUrl}?t=${+new Date()}`
      }
      return {
        uid: file.uid,
        name: file.name,
        url: fileUrl,
        type: file.type,
      }
    })
}

/**
 * 获取其他输入框为空的字段name
 *
 * @param otherInfo - 其它信息集合
 * @returns keys
 */
export const getEmptyOtherInfoKey = (otherInfo: AnyValueObj) => {
  let finalKey = ''
  Object.keys(otherInfo).map((key) => {
    if (otherInfo[key] === undefined) {
      finalKey = key
    }
  })
  return finalKey
}
